module.exports = __webpack_public_path__ + "img/cooperative0_logo34.b5cca322.jpg";